import React from 'react';
import {Button, Col, Row} from 'react-bootstrap';
import mImage from '../assets/m.png';
import GoPay from '../assets/GoPay.png';
import Maestro from '../assets/Maestro.png';
import MasterCard from '../assets/MasterCard.png';
import MasterCardElectronic from '../assets/MasterCardElectronic.png';
import MasterCardSecureCode from '../assets/MasterCardSecureCode.png';
import VerifiedbyVISA from '../assets/VerifiedbyVISA.png';
import Visa from '../assets/Visa.png';
import VisaElectron from '../assets/VisaElectron.png';

const HomePage = () => {
    return (
        <>
            <h2 className={'my-4 pt-4 text-uppercase'}>FORMA – Fitness &amp; Gym</h2>

            <p className="my-4 lead">
                <h3>Bezobslužné fitko v Senici s dôrazom na súkromie a kvalitu</h3>
                Vitajte v novom type fitka v Senici. FORMA ponúka jedinečný koncept bezobslužného
                fitness centra s obmedzenou kapacitou pre vaše maximálne pohodlie. U nás nájdete
                všetko, čo potrebujete na ceste za svojou formou.
            </p>

            <p className="my-4 lead">
                <h3>Naše služby:</h3>
                <b>Open Gym</b> – voľné cvičenie pre registrovaných členov. Žiadne preplnené priestory, iba vy,
                váš tréning a dostatok súkromia.
            </p>

            <p className="my-4 lead">
                <b>Kruhové tréningy s trénerom</b> – skupinové cvičenia pod vedením osobného trénera, ktorý
                vám pomôže posúvať limity bezpečne a efektívne.
            </p>

            <p className="my-4 lead">
                <b>Vstup Premium</b> – chcete absolútne súkromie? Rezervujte si celý fitness priestor len pre
                seba alebo svoj tím.
            </p>

            <p className="my-4 lead">
                FORMA je tu pre všetkých, ktorí chcú trénovať kvalitne, bez kompromisov a v príjemnom
                prostredí. Žiadna recepcia, žiadne zbytočnosti — len vy, vaše ciele a podmienky, ktoré
                vám pomôžu ich dosiahnuť.
            </p>

            <Row>
                <Col xs={4} className="justify-content-left">
                    <Button className={'text-uppercase mt-5 mb-2'} onClick={() => {
                        window.location.href = 'https://online.iclub.sk/#/ucet/prihlasenie';
                    }}>Rezervuj si tréning</Button>
                </Col>
                <Col xs={7} className="d-none d-lg-block">
                    <img src={mImage} alt="m picture" height={300}/>
                </Col>
            </Row>
            <footer className="text-white text-center py-3" style={{backgroundColor:''}}>
                <img src={GoPay} alt="GoPay" height={30} className={'m-3'}/>
                <img src={Maestro} alt="Maestro" height={30} className={'m-3'}/>
                <img src={MasterCard} alt="MasterCard" height={30} className={'m-3'}/>
                <img src={MasterCardElectronic} alt="MasterCardElectronic" height={30} className={'m-3'}/>
                <img src={MasterCardSecureCode} alt="MasterCardSecureCode" height={30} className={'m-3'}/>
                <img src={VerifiedbyVISA} alt="VerifiedbyVISA" height={30} className={'m-3'}/>
                <img src={Visa} alt="Visa" height={30} className={'m-3'}/>
                <img src={VisaElectron} alt="VisaElectron" height={30} className={'m-3'}/>
            </footer>
        </>
    );
}

export default HomePage;
